/** Shared pill dimensions for vehicle card corner badges (collectibility + build score). */
export const VEHICLE_BADGE_SHELL =
  'relative inline-flex items-center justify-center gap-1 min-h-[34px] px-3 py-1.5 rounded-full shadow-lg shadow-black/30 text-sm font-bold leading-normal box-border';

export const VEHICLE_COLLECTIBILITY_BADGE =
  `${VEHICLE_BADGE_SHELL} bg-[#111] text-orange-300 border border-white/[0.12]`;
